function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M42 22.75a2.4 2.4 0 013.28.96A24.08 24.08 0 0148 34.76a2.42 2.42 0 01-2.42 2.4 2.42 2.42 0 01-2.42-2.4c0-3.06-.73-6.06-2.18-8.77A2.4 2.4 0 0142 22.75zm-9.07-4.93a19.26 19.26 0 00-9.14-2.28 18.9 18.9 0 00-18.95 18.8 2.42 2.42 0 01-2.42 2.4A2.42 2.42 0 010 34.34a23.7 23.7 0 0123.79-23.6c4 0 7.93.96 11.44 2.88a2.32 2.32 0 01.97 3.24 2.36 2.36 0 01-3.27.96zm13.44-4.98c.42.48.42 1.08 0 1.5L25.97 36.5a2.48 2.48 0 01-3.45.12 2.43 2.43 0 01-.13-3.42l.13-.12 22.27-20.3a1.09 1.09 0 011.57.06z",
  fillRule: "evenodd"
})));